/**
 * Immersal config registry - allows main.app.immersal to receive config from the active experience.
 * Set by the router before main.app.immersal loads.
 *
 * Each Immersal experience (queens-gardens, future locations) exports its own configImmersal.
 * Position/rotation are now passed directly in the AppImmersalConfig maps array.
 */
import type { AppImmersalConfig } from '@webcore/apps/app.immersal';

export interface ImmersalConfig {
  configImmersal: AppImmersalConfig;
  mapVisualizationEnabled?: boolean;
}

let immersalConfig: ImmersalConfig | null = null;

export function setImmersalConfig(config: ImmersalConfig): void {
  immersalConfig = config;
}

export function getImmersalConfig(): ImmersalConfig {
  if (!immersalConfig) {
    throw new Error(
      'ImmersalConfig not set. Ensure the experience is loaded before main.app.immersal initializes.'
    );
  }
  return immersalConfig;
}
